/**
 * Global API Configuration
 * 
 * Supports environment variables for multi-stage deployments (development, staging, production).
 * Priority order:
 * 1. REACT_APP_API_URL (custom environment variable via .env or hosting platform)
 * 2. Production fallback: '/api' (relative path for reverse proxy / Nginx / Cloudflare / Vercel)
 * 3. Development fallback: 'http://localhost:8000/api' (local standalone backend)
 */

export const API_URL = (
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000/api')
).trim();

export default API_URL;
